import "./App.css";
import React, {lazy, Suspense} from 'react';
import {Link, Route, Routes, useLocation} from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import LoadingScreen from "./components/LoadingScreen.jsx";
import NavBar from "./components/NavBar.jsx";
import {HelmetProvider} from 'react-helmet-async';

// Preload critical components
const HomePage = lazy(() => import('./pages/HomePage.jsx'));
const About = lazy(() => import('./pages/AboutPage.jsx'));
const ProjectPage = lazy(() =>
  import('./pages/ProjectDetailPage.jsx')
    .catch(err => {
      console.error('Error loading ProjectPage:', err);
      return { 
        default: () => (
          <div className="text-center mt-20 text-gray-700">
            <h2 className="text-2xl font-semibold mb-4">Error Loading Project</h2>
            <p>Please try refreshing the page or contact support if the problem persists.</p>
          </div>
        )
      };
    })
);

// Loading component with better UX
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <LoadingScreen />
  </div>
);

const NotFound = () => (
  <div className="flex flex-col items-center justify-center min-h-screen gap-4 text-gray-700">
    <h1 className="text-3xl font-semibold">Page not found</h1>
    <Link to="/" className="text-blue-500 hover:text-blue-600 transition-colors">
      Go back home
    </Link>
  </div>
);

function App() {
    const location = useLocation();

    return (
        <HelmetProvider>
            <div className="App">
                <NavBar/>
                <AnimatePresence mode="wait">
                    <Suspense fallback={<LoadingFallback />}>
                        <Routes key={location.pathname} location={location}>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="/about" element={<About/>}/>
                            <Route path="/projects/:slug" element={<ProjectPage/>}/>
                            <Route path="*" element={<NotFound/>}/>
                        </Routes>
                    </Suspense>
                </AnimatePresence>
            </div>
        </HelmetProvider>
    );
}

export default App; 